import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { ArrowRight } from "lucide-react";
import ExportGif from "../../assets/gif/exportgif.mp4";

export const HeroSection = () => {
  return (
    <div id="hero" className="relative overflow-hidden bg-slate-50">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-100 rounded-full opacity-20"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-slate-200 rounded-full opacity-15"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
          <div className="flex-1 text-center lg:text-left">
            {/* <div className="mb-8">
              <div className="inline-flex items-center gap-2">
                <div className="w-10 h-10 bg-slate-900 rounded-lg flex items-center justify-center">
                  <span className="text-white font-bold text-xl">E</span>
                </div>
                <span className="text-2xl font-bold text-slate-900">
                  Export Stuff
                </span>
              </div>
            </div> */}

            <h1 className="text-4xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
              Automate Global Trade
              <span className="text-blue-600"> in Minutes</span>
            </h1>

            <p className="text-lg lg:text-xl text-slate-600 mb-8 max-w-2xl">
              Connect suppliers, manage documents, track shipments — all in one
              powerful platform designed for modern importers and exporters.
            </p>

            <Link to="/login" className="inline-block">
              <Button
                size="lg"
                className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105"
              >
                Login / Get Started
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="bg-gradient-to-br from-slate-100 to-slate-200 border-2 border-dashed border-slate-300 rounded-2xl w-full max-w-md flex items-center justify-center p-4">
              <video
                src={ExportGif}
                alt="Automate global trade animation"
                className="w-full h-auto rounded-lg shadow-sm"
                autoPlay
                loop
                muted
                playsInline
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
